import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios"; // Import Axios
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Ensure BASE_URL is defined
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import { Helmet } from 'react-helmet';

const Terms = () => {
  return (
    <>

<Helmet>
        <link rel="canonical" href={`https://evventoz.com/terms-conditions`} />
        <title>Terms</title>
      </Helmet>



      <section>
        <NavbarVisitor />
        <div className="container">
          <div className="mt-5 text-start mb-5">
            <h3>
              <strong>Terms & Conditions</strong>
            </h3>

            <div class="row mb-4">
              <h4>I. Acceptance of terms</h4>

              <p>
                We appreciate your use of Evventoz. The purpose of these Terms
                of Service (the &quot;Terms&quot;) is to inform you of your
                legal rights and obligations regarding your use of the Evventoz
                website, located at evventoz.com (the &quot;Site&quot;), and any
                associated software applications or mobile applications
                (referred to as the &quot;Evventoz Platform&quot;). This
                includes, but is not limited to, the provision of information
                via the website, whether it is currently in existence or not,
                that link to the Terms (collectively, the &quot;Services&quot;).
              </p>
              <p>
                All users of Evventoz, past, present, and future, including
                those who access &quot;Evventoz&quot; to manage their claimed
                listings, are bound by these Terms.
              </p>
              <p>
                Kindly carefully read these terms. You are entering into a
                legally binding agreement with Evventoz and/or its affiliates by
                accessing or using the Evventoz Platform. If you disagree with
                the Terms or cannot agree to be bound by them, you might not be
                able to use the Services. You use the Evventoz Platform at your
                own risk, which includes the possibility of encountering
                offensive or otherwise improper content.
              </p>
              <p>
                You must accept the Terms before you may use the Services. You
                can accept the Terms by:
              </p>

              <ul>
                <li>
                  When provided by Evventoz in the user interface for a specific
                  Service, you may choose to accept or agree to the Terms by
                  clicking on them. Alternatively, you may choose to use the
                  Services.
                </li>
                <li>
                  In this instance, you acknowledge and consent that Evventoz
                  will regard your usage of the Services as your continued
                  acceptance of the Terms.
                </li>
              </ul>
              <p>
                The only authority to change the Terms of Service is ours; you
                will not be notified or need to give consent beforehand. You
                have an obligation under the terms of service to regularly
                review and be informed about its obligations. You are considered
                to have consented to the updated policies if you use the website
                or any of its services after it has changed without registering.
                Your use of the Website is contingent upon your adherence to the
                Terms of Service, which includes, but is not limited to,
                adhering to the Terms of Service even in the wake of any
                changes.
              </p>

              <h4>II. Definitions</h4>
              <ul>
                <li>
                  &quot;We&quot;, &quot;Us&quot;, &quot;Our&quot;, and
                  &quot;Evventoz Platform&quot; refer to the Company or the
                  Website/App/Portal Evventoz.
                </li>
                <li>
                  The Terms of Service, along with any incorporated changes,
                  shall be referred to as the &quot;Agreement.&quot;
                </li>
                <li>
                  &quot;User&quot; or &quot;You&quot; or &quot;Your&quot;
                  designates you as the service user. Anybody who accesses or
                  uses the Services with the intent to share, display, host,
                  publish, transact, or upload data, views, or pictures is
                  considered a user. This includes other users who use the
                  Services in tandem with you, such as a user who has access to
                  a &quot;business page&quot; to manage claimed business
                  listings or for other purposes.
                </li>
                <li>
                  &quot;Content&quot; will encompass, among other things,
                  reviews, pictures, photographs, audio, video, location
                  information, neighbouring locations, and any other type of
                  data or information. Content that you post, distribute, or
                  transmit to, through, or in connection with the Services is
                  referred to as &quot;your content&quot; or &quot;User
                  Content.&quot; Examples of this type of content include likes,
                  ratings, reviews, pictures, photographs, messages, profile
                  information, and any other materials that you publicly display
                  or show in your account profile. &quot;Evventoz Content&quot;
                  refers to material produced and made available by Evventoz in
                  relation to the Services, which may include, but are not
                  limited to, visual interfaces, interactive features, graphics,
                  design, compilation, computer code, goods, software, aggregate
                  ratings, reports, and other usage-related data in relation to
                  activities linked to your account, among other elements and
                  components of the Services.
                </li>
              </ul>
              <h4>III. Eligibility to use the services</h4>
              <ul>
                <li>
                  By agreeing to these Terms, you confirm that you are at least
                  eighteen (18) years old and that you are fully capable of
                  understanding and entering into agreements with the terms,
                  conditions, obligations, affirmations, representations, and
                  warranties that are outlined in them.
                </li>
                <li>
                  Adherence to the law. By accessing and using the Services, you
                  attest to your compliance with all applicable laws and
                  regulations in your home country. You acknowledge that you
                  will only use the Services in a way that complies with these
                  Terms, applicable law, and neither ours nor any third
                  party&#39;s legal rights are violated.
                </li>
              </ul>
              <h4>IV. Changes in the terms</h4>
              <p>
                These Terms are subject to revision or modification at any time,
                in Evventoz&#39;s sole discretion. It is your responsibility to
                periodically review these Terms and make sure they are still
                being followed. When you use the Evventoz Platform following a
                modification or change in the Terms, it will be understood that
                you have read, understood, and agreed to be bound by the updated
                or revised terms.
              </p>
              <h4>V. Provision of the services being offered</h4>
              <p>
                1. To give its consumers the most experience and information
                possible, Eventoz is always changing. You understand and agree
                that Evventoz may need to make changes to the form and nature of
                the services it offers. As a result, Evventoz reserves the right
                to modify and alter any of the site&#39;s contents, products,
                and services at any time without prior notice, as well as to
                suspend, cancel, or discontinue any or all of its offerings.
              </p>
              <p>
                2. You understand and agree that you might not be able to access
                the Services, your account information, or any files or other
                material that is stored in your account if Evventoz blocks
                access to it.
              </p>
              <p>
                3. You understand and agree that even while Evventoz may not
                have established a specific upper limit on the quantity of
                transmissions you are permitted to send or receive using the
                Services at this time, Evventoz has the right to do so at any
                time, at its sole discretion.
              </p>
              <p>
                4. Evventoz maintains the right, at any point in the future, to
                impose subscription and/or membership fees on users, with fair
                prior notice, for any good, service, or other feature of the
                Evventoz Platform.
              </p>
              <h6>CALL, SMS MESSAGES AND EMAIL NOTIFICATIONS</h6>
              <ul>
                <li>
                  As part of the Services, Evventoz may contact users by phone,
                  SMS text message, email, app notification, or reminders
                  (henceforth referred to as &quot;notifications&quot;). You
                  agree to receive these messages, and you acknowledge them.
                  Evventoz may distribute these communications &amp; messages
                  via one or more carriers.
                </li>
                <li>
                  By providing Evventoz with your Phone number, you attest that
                  you are the account holder or that you have the account
                  holder&#39;s express consent to use the supplied phone to
                  receive text messages from Evventoz on your registration and
                  other matters.
                </li>
                <li>
                  You could get a regular call, SMS, app notification, or email
                  about your registrations or Evventoz service communications
                  after registering. There may be message and data fees.
                </li>
                <li>
                  You understand and accept that you are in charge of responding
                  promptly to calls, SMS messages, app alerts, and emails, and
                  that reception of these messages is not always guaranteed. You
                  also understand and agree that the operation of your mobile
                  phone provider, internet service provider, and/or mobile phone
                  company, with which you have an account or prepaid card, will
                  determine whether you receive calls, SMS messages, app
                  notifications, and emails. Evventoz disclaims all duty and
                  responsibility for any losses or expenses you may incur as a
                  result of your mobile network, mobile phone provider, or
                  mobile phone business not operating as it should, or from you
                  not getting calls, SMS messages, emails, or app alerts on
                  time.
                </li>
                <li>
                  At any point, you have the option to stop getting call, SMS,
                  email, and app alerts. You may finish the process of opting
                  out of phone, SMS, email, or app notifications on the Evventoz
                  website. You can choose not to receive the messages on your
                  mobile device by sending an email with your phone number to
                  help@evventoz.com.
                </li>
              </ul>
              <h6>MOBILE SOFTWARES &amp; APPS</h6>
              <ul>
                <li>
                  In addition to what is stated in this policy, we may
                  collaborate with partners who employ mobile SDKs, such as the
                  OneSignal Messaging SDK, to passively gather data (referred to
                  as &quot;SDK Information&quot;), which typically aids in the
                  delivery of customised alerts. For the aim of personalising
                  advertisements or content, this information may also be
                  utilised to uniquely identify you across different devices or
                  browsers. Email addresses and other personally identifiable
                  information (PII) may be included in this data, depending on
                  the permissions provided to this application. In addition,
                  this data could contain your mobile ID (such as Android
                  Advertising ID), installed and activated apps, exact position
                  (such as GPS-level data), or WiFi information.
                </li>
                <li>Opting-out of Push Notifications</li>
                <li>
                  Most of the time, you may choose not to get push notifications
                  by going to &quot;Settings&quot; on your smartphone, selecting
                  &quot;Notifications,&quot; and then adjusting the settings for
                  some or all of 4 the applications. (Different device updates
                  or configurations may have an impact on or modify how these
                  options function.)
                </li>
                <li>
                  Disabling &quot;Cross-App&quot; Advertising on Smartphones
                </li>
                <li>
                  You may go to the &quot;settings&quot; on your Apple or
                  Android mobile device and choose not to have your mobile
                  advertising identifiers used for specific interest-based (also
                  known as &quot;cross-app&quot;) mobile behavioural
                  advertising. by starting your device&#39;s Google Settings
                  app, choosing Ads, and then choosing the choice to reject
                  interest-based advertisements. (Different device updates or
                  configurations may have an impact on or modify how these
                  options function.)
                </li>
              </ul>
              <h4>VI. Disclaimer</h4>
              <p>
                You acknowledge and agree to the following disclaimer by using
                Evventoz Services: Only informative objectives are served by the
                Content on these Services. Since the last time the specific
                piece of information was updated, Evventoz disclaims all duty
                for any information that may have been inaccurate or
                out-of-date. Users can use the Evventoz Platform as a platform
                to do business as either service providers or customers. Unless
                otherwise indicated, Evventoz is not a party to any service
                contracts that customers and service providers enter into.
                Additionally, Evventoz does not guarantee admission to the event
                through the use of certain of its services, such as following,
                attending, or travelling to events. It just serves as an
                engagement tool to improve the platform&#39;s user experience.
                Although it has no influence over it, Evventoz goes above and
                beyond to ensure that the representatives of events and
                businesses properly handle your requests. Any portion of the
                Content on these Services may be altered or corrected at any
                moment without prior notification by Evventoz. Evventoz makes no
                guarantees on the truth or quality of any material, including
                event dates, locations, schedules, costs, or other details.
                Unless otherwise indicated, it is assumed that all of the images
                and data on these services are either the property of or
                licenced to Evventoz, or that they were given by third parties
                in accordance with third party licence agreements. If you are
                the copyright owner of any content on these services and you
                believe that the use of the aforementioned material infringes in
                any manner upon Your copyright, please email a takedown request
                (by using the “Contact Us” link on the main page) to the
                webmaster. In your request, please be sure to provide the
                webpage&#39;s specific URL. Every photograph on this page was
                digitally transformed by Evventoz. Without Evventoz&#39;s prior
                written consent, no other party is permitted to copy or reprint
                these digital editions in any format.
              </p>
              <h4>VII. Use of services by you or user</h4>
              <p>Evventoz User Account Including ‘Claim Your Listing’ Access</p>
              <p>
                Some of the functions provided by the Services require the
                creation of an account, such as the ability to &quot;claim your
                business listing.&quot; The way we use any personal information
                you provide us while creating an account is controlled by our
                privacy policy. Maintaining the security and confidentiality of
                your account, any updates and changes made through it, and all
                actions related to it is entirely your responsibility. You also
                need to keep your password private.
              </p>
              <p>
                Registering to use the Services may also be possible if you use
                your login credentials from some third-party social networking
                sites (e.g., Facebook, Linkedin, Google) to access your account.
                By providing us with your social network login credentials, you
                attest that you are the legitimate owner of any such account.
                You give us permission to gather the authentication data you
                provide, together with any additional data that might be
                accessible on or via your social network account in accordance
                with any applicable settings and guidelines.
              </p>
              <p>
                By opening an account with us and/or claiming your company
                listing, you guarantee that all the information you give us is
                true, accurate, and correct, and that you will update it as
                needed to maintain accuracy. You certify to us that you are the
                owner or an authorised agent of the business if you are making
                an account or claiming a business listing. Unless otherwise
                permitted by us, you are not permitted to create multiple
                accounts or business listings, impersonate someone else, create
                or use an account for someone other than yourself, provide an
                email address other than your own, create multiple accounts, or
                use false information to gain access to a business listing on
                the Services that you are not legally entitled to. You
                understand that making false claims about a company listing
                might result in significant financial losses for Evventoz or
                other parties, for which you could be held responsible.
              </p>
              <p>
                Additionally, you bear accountability for all actions taken
                within your account. You consent to providing us with prompt
                notice of any unauthorised use of your account so that we can
                take the appropriate remedial action. Additionally, you commit
                to keeping your Evventoz account private and accepting
                responsibility for any unauthorised access that occurs.
              </p>
              <p>
                You consent to receiving certain communications related to the
                Evventoz Platform or Services by registering an account. For
                instance, other users may leave you messages, connect requests,
                comments, or follow the actions you take on your account. By
                contacting us or going via your account settings, you may change
                your choices or opt-out of receiving non- essential emails.
              </p>
              <h6>Others Terms</h6>
              <p>
                You acknowledge and agree that you will only use the Services
                for the reasons allowed by (a) the Terms and (b) any applicable
                legislation, rule, or standard operating procedure in the
                relevant jurisdictions.
              </p>
              <p>
                Except as permitted by &quot;Claim Your Listing&quot; access,
                you undertake to use Evventoz&#39;s data (whether accessible
                through the Services or other channels like APIs) exclusively
                for personal use and not for any commercial use, unless
                expressly authorised in writing by Evventoz.
              </p>
              <p>
                Unless expressly permitted in writing by means of a separate
                agreement with Evventoz, you undertake not to access (or attempt
                to access) any of the Services via any means other than the
                interface that is provided by Evventoz. You expressly agree to
                follow the guidelines in any robots.txt file that may be present
                on the Services and to refrain from accessing (or attempting to
                access) any of the Services using automated means, including the
                use of scripts or web crawlers.
              </p>
              <p>
                By using the Services (or the servers and networks that are
                linked to them), you agree not to participate in any behaviour
                that affects or interferes with the Services. You will not
                engage in spamming, which includes, but is not limited to, any
                unsolicited emailing, posting, or messaging, nor will you remove
                or edit any content or information posted by any other User(s).
              </p>
              <h4>VIII. Content</h4>
              <p>Ownership of Proprietary Rights and Evventoz Content</p>
              <p>
                You understand that the Services are original works that have
                been created, assembled, edited, revised, chosen, and organised
                by us and other parties using techniques and standards of
                judgement that have been developed and applied after investing a
                significant amount of time, money, and effort. You also
                understand that these materials represent important intellectual
                property that we and those other parties have developed. You
                also understand that Evventoz may designate some information as
                secret and that you are not permitted to divulge such
                information without the company&#39;s prior written
                authorization. The Services and our Content are exclusively
                owned by us under copyright. The copyrights, trademarks, service
                marks, logos, trade names, trade dress, and other intellectual
                and proprietary rights related to the Services and Evventoz
                Content are also exclusively owned by us worldwide
                (collectively, the &quot;IP Rights&quot;). These rights may be
                shielded by copyright, patents, trademarks, and other relevant
                intellectual property and proprietary rights and laws.
              </p>
              <p>
                During and after the term of this agreement, you agree to
                protect Evventoz&#39;s proprietary rights and the proprietary
                rights of anyone else with rights in the Services, and to abide
                by any reasonable written requests from us, our suppliers, and
                content licensors, or in any other way to safeguard the
                contractual, statutory, and common law rights of others in the
                Services. You understand and agree that all legal rights, title,
                and interest in and to the Services belong to Evventoz (or
                Evventoz licensors), including any intellectual property rights
                that may exist in the Services (whether or not those rights are
                registered, and anywhere in the world such rights may exist).
              </p>
              <p>
                You also understand that Evventoz may designate some information
                as secret and that you are not permitted to divulge such
                information without the company&#39;s prior written
                authorization. Nothing in the Terms grants you permission to use
                any of Evventoz&#39;s trade names, trademarks, service marks,
                logos, domain names, or other distinguishing brand aspects,
                unless you and Evventoz have agreed otherwise in writing.
              </p>
              <p>
                You also agree not to remove, hide, or obliterate any copyright
                or other proprietary notice or source identifier, including
                without limitation the size, colour, location, or style of any
                proprietary mark(s); or to use any framing techniques to enclose
                any trademark, logo, or other proprietary information of
                Evventoz. Any infringement will result in proper legal action
                being taken against you in the proper place in order to pursue
                all available/possible remedies under the applicable laws of the
                nation where the violation occurred. All or any portion of the
                Evventoz Content may not be altered, copied, publicly displayed,
                or used for any other purpose without express permission from
                Evventoz.
              </p>
              <p>
                We neither guarantee nor represent that your use of content
                found on the Services won&#39;t violate the intellectual
                property rights of unaffiliated or third parties, to the maximum
                degree allowed by applicable law. In the event that you learn of
                any allegation that the Services violate any copyright,
                trademark, or other legal, contractual, intellectual, statutory,
                or common law rights, you undertake to contact us straight away.
              </p>
              <h6>Your License to Evventoz Content</h6>
              <p>
                We provide you the right to access and use the Services for
                personal, restricted, non- exclusive, and non-transferable
                purposes, as stated in these Terms. You agree not to use the
                Services in any way that violates these Terms or for any illicit
                purpose. Only personal, non- commercial use of the information
                made accessible through the Services is permitted. Except in
                cases where we have given our express permission, you agree not
                to use, copy, display, distribute, alter, broadcast, translate,
                reproduce, reformat, incorporate into advertisements and other
                works, sell, promote, create derivative works, or in any other
                way profit from or allow others to profit from any Evventoz
                Content in whole or in part. We do not give you any further
                rights, implicit or otherwise, to the Services, Evventoz
                Content, or our intellectual property, unless otherwise
                specifically granted to you in writing.
              </p>
              <p>
                If you violate any of the licence terms outlined in this
                Section, your ability to use the Services will be immediately
                terminated, and depending on the situation, you may also be held
                liable for infringement of intellectual property rights,
                including copyright.
              </p>
              <h6>Evventoz License to Your or User Content</h6>
              <p>
                A perpetual, irrevocable, worldwide, non-exclusive,
                royalty-free, sublicensable, transferable licence and right to
                use Your Content (including content shared by any business user
                with access to a &quot;event page or business page&quot; to
                manage claimed business listings or otherwise) and all
                intellectual property rights therein are hereby irrevocably
                granted to Evventoz for any purpose, including API partnerships
                with third parties and in any media now in existence or in the
                future. The term &quot;use&quot; refers to the following:
                creating derivative works, promoting, including into ads and
                other works, copying, displaying, distributing, changing,
                translating, reformatting, and, in the case of third-party
                services, permitting users and others to do the same. By
                submitting your name or username, you give us permission to use
                it in connection with Your Content. Any claims and assertions of
                moral rights or attribution with respect to Your Content made
                against Evventoz or its Users, any third-party services and
                their users, are thus irrevocably waived and caused to be
                waived.
              </p>
              <h6>Representations Regarding Your or User Content</h6>
              <p>
                Your Content is your responsibility. You declare and guarantee
                that: Your Content was not lifted verbatim from or partially or
                entirely based on any other content, work, or website; You are
                the only author of Your Content, the owner of All Rights to Your
                Content, or you have received express permission to submit Your
                Content from the owner of All Rights. Your Content is truthful
                and accurate; it does not violate the Guidelines and Policies or
                any applicable laws; it was not submitted through the use of any
                automated process, such as a script bot; usage of Your Content
                by us, third-party services, and our users will not violate or
                infringe any rights of yours or any third party. If Your Content
                is a review, you represent and warrant that you are the only
                author of the review; that the review accurately describes your
                actual dining experience; that you did not receive payment or
                any other form of compensation for writing the review; and that
                you had no personal, financial, or competitive incentive to
                write or post a review that did not fairly express your honest
                opinion.
              </p>
              <p>
                You take entire responsibility for any risks relating to Your
                Content, including the possibility that someone will rely on its
                authenticity, correctness, or dependability, or that you will
                reveal personally identifiable information in Your Content.
                Although we have the right to delete Content, we have no control
                over user-posted activities or content, and we cannot ensure
                that any Content is accurate, reliable, or of high quality. You
                understand and agree that Evventoz is not responsible for any
                content uploaded by users, and that the user is solely liable
                for any and all liabilities arising from such content.
              </p>
              <h6>Content Removal</h6>
              <p>
                We retain the right, in our sole discretion, to delete, block,
                or deactivate access to any material that we deem objectionable,
                in violation of the Terms, or otherwise detrimental to the
                Services or our users, at any time and without prior notice. We
                shall not be under any obligation to return any of Your Content
                to you, save from the requirements of relevant law. At our sole
                discretion, any review that violates the Guidelines and
                Policies, is disparaging, libellous, or hateful, or lacks
                credible proof, may be removed.
              </p>
              <h6>Third Party Content and Links</h6>
              <p>
                A portion of the content accessed via the Services could contain
                or contain links to content owned by third parties, such
                tickets, event badging, or third-party hotel reservation
                services. Please be aware that the terms of service and privacy
                policies that apply to the relevant third party will control
                your usage of such third party services. We could get company
                names, phone numbers, and other contact details from outside
                suppliers whose information comes from open sources. Regarding
                any product, service, advertising, or other material that
                appears in or is linked to from the Services, we have no control
                over it and neither do we make any representations or
                endorsements regarding its correctness, relevancy, copyright
                compliance, legality, completeness, timeliness, or quality.
                Before or after posting content from third parties on our
                services, we don&#39;t review or look into it. We retain the
                right to edit, add to, or remove any errors or omissions from
                any part of the content available on the Services at our sole
                discretion and without being under any legal pressure. Any
                updates, alterations, or changes to any content available on the
                Services may be verified by us at any time, in our absolute
                discretion and without any obligation. However, we will not be
                held responsible for any delays or errors resulting from such
                updates. You understand and accept that Evventoz has no control
                over the availability of any such other websites or resources,
                and that it disapproves of any advertisements, goods, or other
                items found on or accessible through them.
              </p>
              <p>
                Content from third parties, including user-posted content, does
                not represent the opinions of our company, its parent, its
                subsidiaries, its affiliates, its branches, its officers,
                directors, or its shareholders. Furthermore, none of the third
                party content providers or licensors are endorsing or certifying
                any of the material made accessible through the Services.
                Regarding any of Your Content or other content from third
                parties, we take no obligation or accountability.
              </p>
              <p>
                You additionally understand and agree that Evventoz shall not be
                responsible for any loss or damage that you may sustain as a
                result of the accessibility of those outside websites or
                resources, or as a result of your reliance on the existence,
                completeness, or accuracy of any advertisements, goods, or other
                materials on, or accessible from, such websites or resources. We
                specifically disclaim any duty for any offensive, defamatory,
                unlawful, intrusive, unfair, or infringing content provided by
                third parties, without limiting the generality of the
                aforementioned.
              </p>
              <h6>User Reviews</h6>
              <p>
                Evventoz does not endorse any events, venues, or services based
                on user evaluations or ratings. Numerous user evaluations and
                ratings are received by Evventoz, and they represent the
                perspectives of the people. It is important to note that every
                single review that is submitted on Evventoz represents the
                user&#39;s or reviewer&#39;s personal opinion alone. Evventoz is
                an impartial platform that only offers a channel of
                communication for users and reviewers, as well as for owners and
                representatives of events, venues, and companies who have access
                to the company page. The reviews that these advertisers receive
                have no bearing on the ads that are posted on the Evventoz
                Platform. Since we are an impartial platform, we do not mediate
                disputes; however, should a review be submitted that the listing
                owner or representative does not believe to be accurate, the
                best course of action would be for the representative to get in
                touch with the reviewer or post a public response to address any
                miscommunications. The representative may contact us by email at
                info@evventoz.com to report any violations of Evventoz policies
                that they think a specific user&#39;s review may have violated.
                In its sole discretion, Evventoz has the right to remove a
                review if it violates the terms, content standards and policies,
                or is detrimental to the services.
              </p>
              <h4>IX. Content guidelines and privacy policy</h4>
              <h6>Content Guidelines</h6>
              <p>
                You certify that you have read, comprehended, and accepted our
                content-related guidelines and policies.
              </p>
              <p>Privacy Policy</p>
              <p>
                You attest to having read, comprehended, and accepted our
                privacy policy. Please be aware that if we feel it is reasonably
                necessary to: (i) take action regarding suspected illegal
                activities; (ii) enforce or apply our Terms and Privacy Policy;
                (iii) comply with legal process or other government inquiry,
                such as a search warrant, subpoena, statute, judicial
                proceeding, or other legal process/notice served on us; or (iv)
                protect our rights, reputation, and property, or that of our
                users, affiliates, or the general public., then we may disclose
                information about you to third parties or government
                authorities.
              </p>
              <h4>X. Restrictions on use</h4>
              <p>
                In using the Services, you expressly consent, without limiting
                the scope of these Terms, not to publish or send any material
                (including reviews) or participate in any activity that, in our
                sole discretion:
              </p>
              <p>1. Disregard our policies and guidelines;</p>
              <p>
                2. Is indecent, defamatory, discriminating, vulgar, profane,
                obscene, libellous, hateful, or otherwise unpleasant; it also
                relates to or encourages money laundering or gambling; it
                infringes upon the privacy of another person, particularly their
                physical private.
              </p>
              <p>
                3. Makes up an untrue or purposefully inaccurate evaluation, or
                ignores facts and offerings, ambiance, or other aspects of the
                company you are evaluating.
              </p>
              <p>
                4. Consists of content that transgresses the guidelines set out
                by the Services; 5. Is in violation of any third-party rights,
                such as the rights to privacy, publicity, copyright, trademarks,
                patents, trade secrets, or any other kind of intellectual
                property or proprietary rights;
              </p>
              <p>
                5. Infringes upon the rights of any third party, including but
                not restricted to copyright, trademarks, patents, trade secrets,
                and other intellectual property or proprietary rights;
              </p>
              <p>
                6. Makes false accusations against others or details violent
                altercations;
              </p>
              <p>
                7. Is against the law, or contravenes any federal, state, or
                municipal legislation or regulations (such as when insider
                information is disclosed or traded in contravention of
                securities law);
              </p>
              <p>8. Attempts to pose as someone or something else;</p>
              <p>
                9. Disguises or makes an effort to conceal the source of Your
                Content, such as, but not restricted to: (i) submitting Your
                Content under a fictitious name or false pretences; or (ii)
                hiding the IP address that Your Content is submitted from; is
                used with knowledge and intent to disseminate any information
                that: (i) is clearly untrue; (ii) is blatantly offensive; (iii)
                is threatening, deceptive, or obscene, but may be fairly
                interpreted as true; or (iv) is used to harass a person,
                organisation, or agency in order to obtain money or inflict harm
                on any individual;
              </p>
              <p>
                10. Creates or results in a conflict of interest or functions as
                a dishonest kind of advertising;
              </p>
              <p>
                11. Is commercial in character, which includes, but is not
                limited to, spam, polls, competitions, pyramid schemes, postings
                or reviews that are deleted or submitted in return for money,
                postings or reviews that are withdrawn or submitted by the
                company that is the subject of the review, or other promotional
                materials;
              </p>
              <p>
                12. Indicates or claims that Your Content is supported or
                promoted by us in any manner;
              </p>
              <p>
                13. Contains content that is not in English or the language
                appropriate to such items or services, if they are offered in
                other languages;
              </p>
              <p>
                14. Misrepresents, lies about, or withholds your connection to
                any other individual or organisation;
              </p>
              <p>
                15. Unauthorised access to or usage of another user&#39;s
                account;
              </p>
              <p>
                16. Distributes malware, files, or programmes, such as computer
                viruses, that can corrupt, damage, or restrict the operation of
                any computer hardware, software, or electronic communications
                equipment;
              </p>
              <p>
                17. tampers with, interferes with, or eliminates the ability to
                utilise any aspect of the services, servers, or networks that
                are linked to the services;
              </p>
              <p>
                18. &quot;Hacks&quot; or gains unauthorised access to any of our
                private or proprietary data, another user&#39;s data, or any
                other data;
              </p>
              <p>
                19. Breaks any contractual or fiduciary responsibility (for
                instance, by divulging sensitive or private information of your
                client or employer in violation of a non-disclosure, consulting,
                or employment agreement);
              </p>
              <p>
                20. Attempts to extract source code from the Services by
                decompilation, disassembly, reverse engineering, or other
                methods;
              </p>
              <p>
                21. Disables, obstructs, damages, or interferes in any way with
                security-related features, or those that impose restrictions on
                using the Services;
              </p>
              <p>
                22. Disregards any limitations imposed by robot exclusion
                headers on the Services, if any, or finds a way around any
                safeguards put in place to restrict or prohibit access to the
                Services;
              </p>
              <p>
                23. Gathers, retrieves, or retains personal data about other
                Service users;
              </p>
              <p>24. Is posted by a bot;</p>
              <p>25. Harms minors in any way;</p>
              <p>
                26. Endangers public order, friendly relations with foreign
                states, the unity, integrity, defence, security, or sovereignty
                of India or the nation of use; encourages the commission of any
                crime that is punishable by law; obstructs the investigation of
                any crime; or denigrates any other country;
              </p>
              <p>
                27. Alters, duplicates, gathers, or crawls, exhibits, releases,
                grants permissions, vends, leases, rents, loans, transfers, or
                engages in any other kind of commercialization about the
                Services or Our Content; or
              </p>
              <p>28. Efforts to carry out any of the preceding.</p>
              <p>
                You understand that Evventoz is under no duty to keep an eye out
                for Terms violations during your use of the Services or anyone
                else&#39;s, or to review or modify any material. Nevertheless,
                we have the right to do so in order to manage and enhance the
                Services (including, but not limited to, fraud prevention, risk
                assessment, investigation, and customer support purposes), to
                make sure you abide by the Terms, and to comply with any
                applicable laws, orders, decrees, administrative agencies, or
                other governmental bodies.
              </p>
              <p>
                By using the Evventoz Platform/Services, you guarantee Evventoz
                that you will only use them for authorised reasons and that you
                won&#39;t break any relevant federal, state, municipal, or
                federal laws, rules, or ordinances, or international law. You
                agree not to encumber or allow to exist any lien or security
                interest on the subject matter of these Terms, or to upload,
                post, email, transmit, or otherwise make available any
                unsolicited or unauthorised advertising, promotional materials,
                junk mail, spam mail, chain letters, or any other form of
                solicitation. You also agree not to represent or warrant on
                behalf of Evventoz in any way.
              </p>
              <p>
                Any content you post will be governed by the applicable laws in
                India and the nation in which it is used. It may also be
                disabled or the subject of an inquiry under those laws.
                Furthermore, Evventoz reserves the right to immediately block
                your access to and use of the Evventoz Platform, remove any
                content or comments uploaded by you that is not in compliance,
                and take appropriate legal action using the remedies that would
                be available to it under various statutes if it is determined
                that you are in violation of the laws and regulations, these
                terms, or the platform&#39;s privacy policy.
              </p>
              <h4>XI. User feedback</h4>
              <p>
                Any ideas, suggestions, modifications, or documents pertaining
                to Evventoz&#39;s current business (collectively,
                &quot;Feedback&quot;) that you send or share agree that: (i)
                Evventoz is not obligated to keep any information confidential;
                (ii) Evventoz is free to use the Feedback without limitation and
                that it does not contain any proprietary, secretive, or
                confidential information belonging to third parties. (iv) By
                providing the Feedback, you grant Evventoz a binding,
                non-exclusive, royalty-free, perpetual, worldwide licence to
                use, modify, develop, publish, distribute, and sublicense the
                Feedback. You irrevocably waive, against Evventoz and its users,
                any claims or assertions of any kind with regard to such a
                licence. (iii) It&#39;s possible that Evventoz has already
                received similar Feedback from another user, or it&#39;s
                currently being considered or developed.
              </p>
              <p>
                Kindly limit your feedback to specific comments about
                Evventoz&#39;s current goods or marketing methods. Do not submit
                any proposals that Evventoz is not allowed to accept or take
                into consideration due to policy.
              </p>
              <p>
                Despite the aforementioned disclaimer, neither Evventoz nor any
                of its employees will accept or take into consideration
                unsolicited ideas, including those for new or improved products
                or technologies, advertising campaigns, promotions, processes,
                materials, marketing strategies, or product names. Please
                refrain from sending Evventoz or any of its staff any
                unsolicited ideas, original creative artwork, recommendations,
                or other works (collectively, &quot;Submissions&quot;) in any
                format. This guideline aims to prevent any miscommunications or
                disagreements when Evventoz goods or marketing tactics appear
                similar to concepts that are submitted to Evventoz. The
                following rules will apply to your Submissions regardless of
                what your letter states if you still give us your ideas in spite
                of our request that you not do so.
              </p>
              <p>Terms of Idea Submission</p>
              <p>
                You acknowledge and agree that: (1) Evventoz will automatically
                own your Submissions and their contents without paying you any
                money; (2) Evventoz may use or redistribute the Submissions and
                their contents for any reason or in any manner; (3) Evventoz is
                under no duty to review the Submission; and (4) Evventoz is
                under no obligation to maintain the confidentiality of any
                Submissions.
              </p>
              <h4>XII. Advertising</h4>
              <p>
                Advertisements and promotions may be displayed on some Services,
                which are funded in part by advertising revenue. These adverts
                could be relevant to inquiries made via the Services,
                information held on the Services, or other information. Without
                providing you with prior notice, Evventoz reserves the right to
                alter the way, method, and scope of its advertising on the
                Services. You acknowledge that Evventoz may display such
                advertising on the Services in exchange for Evventoz giving you
                access to and usage of the Services.
              </p>
              <p>
                A portion of the website could include promotional content,
                advertisements, or other materials that users or other parties
                have contributed to Evventoz. It is solely the responsibility of
                the entity submitting the information or material to make sure
                that everything submitted for inclusion on the Evventoz Platform
                or mobile applications conforms with relevant national and
                international legislation. All correspondence, business
                dealings, participation in promotions, and payments for related
                goods and services, as well as any other terms, conditions,
                warranties, or representations pertaining to such dealings, with
                advertisers other than Evventoz found on or through the Evventoz
                Platform and/or mobile apps, shall be between you and such
                advertiser. Any mistake or omission, inaccurate advertising
                material, loss or damage of any kind resulting from any such
                dealings, or from the existence of such other advertiser(s) on
                the Evventoz Platform and mobile application, shall not give
                rise to liability against Evventoz.
              </p>
              <h4>
                XIII. Disclaimer of warranties, limitation of liability, and
                Indemnification
              </h4>
              <h6>Disclaimer of Warranties</h6>
              <p>
                It is understood and agreed upon by you that the services are
                offered &quot;as is&quot; and &quot;as available&quot; and that
                using them is at your own risk. Evventoz, its affiliates, and
                each of their respective officers, directors, employees, agents,
                affiliates, branches, subsidiaries, and licensees (collectively,
                the &quot;Evventoz PARTIES&quot;) disclaim all warranties,
                express or implied, with regard to the services, including
                mobile applications, and your use of them, to the fullest extent
                permitted by applicable law. THE Evventoz PARTIES MAKE NO
                WARRANTIES OR REPRESENTATIONS THAT THE SERVICES HAVE BEEN AND
                WILL BE PROVIDED WITH DUE SKILL, CARE AND DILIGENCE OR ABOUT THE
                ACCURACY OR COMPLETENESS OF THE SERVICES&#39; CONTENT AND ASSUME
                NO RESPONSIBILITY, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE
                LAW. Regarding any (I) mistakes, inaccuracies, or errors in
                content; (II) personal injury or property damage of any kind
                arising from your use of and access to the services, (III) Any
                unauthorised use or access to our servers, as well as any and
                all personally identifiable data kept on them, (V) Any bugs,
                viruses, Trojan horses, or the like that may be sent to or via
                the services through the actions of any third party, (IV) ANY
                INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE
                SERVICES, (VI) Any data or content loss that you may have
                experienced from using the services, and/or (VII) any errors or
                omissions in any content, or any loss or damage of any kind
                resulting from using any posted, emailed, It is entirely your
                responsibility to determine and assume responsibility for any
                material downloaded or otherwise obtained through the use of the
                services. You will also be held liable for any loss of data or
                damage to your computer system or other device resulting from
                the download of any such material. The Evventoz Parties shall
                not participate in any transaction involving third-party
                suppliers of goods or services, nor shall they assume any
                liability or responsibility for such transactions. All of your
                communications and interactions with other users of the
                services, as well as any other people you communicate or
                interact with as a result of using the services, are solely your
                responsibility. NOTHING YOU OBTAIN FROM Evventoz OR THROUGH OR
                FROM THE SERVICES, WHETHER ORAL OR WRITTEN, SHALL CREATE ANY
                WARRANTY NOT EXPRESSLY STATED IN THE TERMS. You agree that when
                using the services, you will not use any trade mark, service
                mark, trade name, or logo of any company or organisation in a
                way that is likely or intended to cause confusion about the
                owner or authorised user of such marks, names, or logos, unless
                you have received express written authorization from Evventoz to
                do so.
              </p>
              <h6>Limitation of Liability</h6>
              <p>
                To the maximum extent permitted by applicable law, THE Evventoz
                PARTIES WILL NEVER BE LIABLE TO YOU FOR ANY DAMAGES ARISING FROM
                ANY OF THE FOLLOWING: (I) ERRORS, MISTAKES, OR INACCURACIES OF
                CONTENT; (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE
                WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE
                SERVICES, INCLUDING MOBILE APP; (III) ANY UNAUTHORISED ACCESS TO
                OR USE OF OUR SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
                STORED Consequently, (IV) any disruption or cessation of
                transmission to or from our servers, (V) any bugs, viruses,
                Trojan horses, or the like that could be transmitted to or via
                the services by any third party, (VI) ANY DATA OR CONTENT LOSS
                YOU MAY HAVE FROM THE SERVICES Whether based on a warranty,
                contract, tort, or other legal theory, and whether or not the
                Evventoz Parties are informed of the possibility of such
                damages, (VII) ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY
                LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF
                ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA
                THE SERVICES, AND/OR (VIII) THE DISCLOSURE OF INFORMATION
                PURSUANT TO THESE TERMS OR OUR PRIVACY POLICY, (X) Any loss or
                damage that you may sustain, including but not limited to loss
                or damage resulting from your reliance on the accuracy,
                completeness, or existence of any advertisement, or as a result
                of any relationship or transaction between you and any
                advertiser 14 or sponsor whose advertisement appears on the
                services; (IX) Your failure to keep your password or account
                details secure and confidential. Under no circumstances will the
                Evventoz Parties be liable to you for any indirect, incidental,
                special, punitive, exemplary, or consequential damages,
                regardless of how the damages were caused or the theory of
                liability applied. This includes, but is not limited to, any
                loss of profit (whether incurred directly or indirectly), any
                loss of goodwill or business reputation, any suffered loss of
                data, the cost of purchasing replacement goods or services, or
                any other intangible loss. Moreover, unless explicitly agreed to
                in writing by Evventoz, the Evventoz Parties&#39; total
                liability to you for any action you take against them will
                always be capped at one hundred Indian rupees (RS 100.00).
              </p>
              <p>
                The limits or exclusions in this section may not apply to you as
                a consumer if you live in a country or territory where it is
                illegal to limit or exclude consequential, direct, indirect, or
                other damages.
              </p>
              <h6>Indemnification</h6>
              <p>
                As a result of, or in connection with: (i) Your Content; (ii)
                your unauthorised use of the Services, or products or services
                included or advertised in the Services; (iii) your access to and
                use of the Services; (iv) your violation of any rights of
                another party; and (v) any other third party claims, damages
                (actual and/or consequential), actions, proceedings, demands,
                losses, liabilities, costs and expenses (including reasonable
                legal fees) suffered or reasonably incurred by us; you agree to
                indemnify, defend, and hold harmless the Evventoz Parties from
                and against these third parties.; or (v) any violation of these
                terms, which includes, but is not limited to, any infringement
                by you on any third party&#39;s copyright or intellectual
                property. Without your previous approval, we shall have the
                exclusive authority to resolve, negotiate, and pay any and all
                claims or causes of action that are made against us. You
                undertake to assist us in defending these claims, and we retain
                the right, at your expense, to take exclusive defence and
                control over any issue for which you are obligated to provide
                indemnification. You undertake not to settle any case without
                first obtaining our written approval in which we are listed as
                defendants and/or for which you are obligated to provide
                indemnification. When we learn of any such claim, action, or
                proceeding, we shall make a good faith attempt to let you know
                about it.
              </p>
              <h4>XIV. Termination of your access to the services</h4>
              <p>
                You may always use the options on your profile area, the
                &quot;Contact Us&quot; link at the bottom of every page, or
                write us at help@Evventoz.com to deactivate your account at any
                moment.
              </p>
              <p>
                In our sole discretion, we may stop your use of the Services and
                prevent you from accessing them for any reason or no reason at
                all, including your: (i) failure to utilise the Services; or
                (ii) breach of these Terms. You understand and agree that we may
                immediately deactivate or delete your account and all connected
                information, and/or block any further access to your account or
                the Services. You also agree that such termination of your
                access to the Services may be effected without prior notice.
              </p>
              <p>
                We reserve the right, in our sole discretion, to keep all
                information gathered from your use of the Services if you use
                them in violation of these Terms. Additionally, you accept that
                in the event that your access to the Services is discontinued or
                terminated, we won&#39;t be held accountable to you or any other
                person.
              </p>
              <h4>XV. General terms</h4>
              <p>Interpretation:</p>
              <p>
                These Terms&#39; section and subject titles are just for
                reference; they are not intended to be used to interpret any of
                the terms inside.
              </p>
              <p>Entire Agreement and Waiver:</p>
              <p>
                The &quot;Privacy Policy&quot; and the Terms will serve as the
                whole understanding between you and us about the Services. A
                single or partial exercise of any right, power, or privilege by
                either party shall not preclude the exercise of that right or
                any other right, power, or privilege in the future. Neither our
                failure nor our delay in exercising any right, power, or
                privilege under the Terms shall operate as a waiver of such
                right or acceptance of any variation of the Terms.
              </p>
              <p>Severability:</p>
              <p>
                Any portion of these Terms that a court finds to be illegal,
                invalid, or unenforceable for any reason will be considered to
                be severed from the rest of the Terms, which will still be in
                full force and effect.
              </p>
              <p>Partnership or Agency:</p>
              <p>
                You and Evventoz are not partners or agents of one another, and
                nothing in these Terms will be interpreted as granting you the
                ability to bind Evventoz in any way.
              </p>
              <p>Governing Law/Waiver:</p>
              <p>
                The laws of India shall apply to these Terms. Any disputes
                arising under this agreement shall be exclusively subject to the
                jurisdiction of the courts located in Delhi or New Delhi.
              </p>
              <p>
                Any legal action you take against us must be started within a
                year of the alleged harm&#39;s initial occurrence. Regardless of
                any statute of limitations or other law to the contrary, the
                failure to commence the action within that time frame will
                permanently bar any claims or causes of action pertaining to the
                same facts or occurrence. Any failure on our part to enforce or
                exercise any related right or provision of these terms within
                this period will not be deemed a waiver of such right or
                provision.
              </p>
              <p>Linking and Framing:</p>
              <p>
                It&#39;s forbidden to frame the Services. You may link to the
                Services, but only if you acknowledge and agree not to link the
                Services to any website that violates any intellectual property,
                proprietary, privacy, or publicity rights, or that contains any
                inappropriate, profane, defamatory, infringing, obscene,
                indecent, or unlawful topic, name, material, or information. 16
                We reserve the right to promptly terminate your access to and
                usage of the Services in the event that this clause is broken.
              </p>
              <h4>XVI. Grievance Officer</h4>
              <p>
                In accordance with the applicable laws, the name and contact
                details of the Grievance Officer are provided below: Email
                ID: officer@Evventoz.com
              </p>
              <h4>
                XVII. Notice of copyright infringement and grievance redressal
                mechanism
              </h4>
              <p>
                When end users or other third parties upload or transmit content
                on the Evventoz Platform or promote goods there, Evventoz will
                not be held responsible for any copyright infringement resulting
                from such activity. We demand that users of the Services respect
                the intellectual property rights of others. When it is
                appropriate and in our discretion, we may limit access to or
                delete content from the Services that violates the copyright
                rights of third parties. Additionally, we have the right to
                block or remove any links or references to websites that host
                illegal content or engage in illegal activities. We reserve the
                right, at our sole discretion, to cancel any user&#39;s access
                to use the Services if they regularly violate the copyrights of
                others. In the event that you feel that content on the Services
                violates your copyright, you must take the following actions to
                register a notification:
              </p>

              <ul>
                <li>
                  List the copyrighted content that you believe has been
                  violated in writing; • List the content on the Services that
                  you believe violates copyrighted content in writing, and
                  include enough details to reasonably pinpoint the location of
                  the allegedly violating content (such as the user name of the
                  alleged violator and the company name it is listed under);
                </li>
                <li>
                  Include the statement as follows: &quot;I have a good faith
                  belief that the use of the content on the Services as
                  described above is not authorised by the copyright owner, its
                  agent, or law&quot; ;
                </li>
                <li>
                  Include the phrase: &quot;I swear under penalty of perjury
                  that the information in my notice is accurate and I am the
                  copyright owner or I am authorised to act on the copyright
                  owner&#39;s behalf&quot; ;
                </li>
                <li>
                  Give your contact details, such as your address, phone number,
                  and (if applicable) email address;
                </li>
                <li>Sign with a physical or digital signature;</li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
};

export default Terms;
